import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTable, MatTableDataSource} from "@angular/material/table";
import {FilterRecallRecord} from "../../../../global/types";
import { FilterRequests } from 'src/app/core/services/filter-requests.service';
import { FiltersService } from 'src/app/core/services/filters.service';
import { ContractModel } from 'src/app/global/contract-filter-model';


@Component({
    selector: 'filter-recall-panel',
    templateUrl: './filter-recall-panel.component.html',
    styleUrls: ['./filter-recall-panel.component.scss'],
    standalone: false
})


export class FilterRecallPanelComponent implements OnInit {
  @Input() divDataView: string = "";
  @Output() hideFilterRecallPanel = new EventEmitter<string>();
  @Output() recallSavedFilters = new EventEmitter<string>();

  displayedColumns: string[] = [
    'selectedItem',
    'filterName',
    'Region',
    'Countries',
    'lastUpdateDate',
    'dateCreated'
  ];

  @Input() title: string = '';
  @Input() serviceType: string | undefined;

  @ViewChild(MatTable) table!: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator | any;
  @ViewChild(MatSort) sort!: MatSort | any;

  showNoData = false;
  showLoader = true;
  hideApplyButton = false;
  dataSource: MatTableDataSource<FilterRecallRecord> = new MatTableDataSource();
  isCountryVisible = true;

  filterName = '';
  Region = [];
  Countries = '';
  Period = '';
  Templates = '';
  H5 = [];
  H7 = [];

  // contact model
  TopLevelContractGroup = []
  SecondLevelContractFilter = []
  ThirdLevelContractFilter = []
  FourthLevelContractFilter = []
  Accts = [];

  disablePageSelection = false;
  totalRows = 0;
  currentPage = 0;
  pageIndex: number | undefined;

  constructor(
      private filterRequests: FilterRequests,
      private filterService: FiltersService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.isCountryVisible = this.divDataView === 'Distributor' ? false : true;
    if(!this.isCountryVisible)
      this.displayedColumns = this.displayedColumns.filter(col => col !== 'Countries');

    await this.getSavedFilterSets();
  }


  async getSavedFilterSets() {

    this.showLoader = true;
    this.disablePageSelection = true

    return await this.filterRequests.getSavedFilterSets(this.divDataView).then(response => {
      var data = response.data.savedFilters;
      if (data[0] === undefined) {
        this.showNoData = true;
        this.hideApplyButton = true;

      } else {
        if (this.divDataView == "Contract") {
          data = data.filter((val: any) => (val.hasOwnProperty("divisionDataView") && val["divisionDataView"] == 0));
        } else if (this.divDataView == "QSR") {
          data = data.filter((val: any) => val.hasOwnProperty("divisionDataView") && val["divisionDataView"] == 2);
        } else if (this.divDataView == "Distributor") {
          data = data.filter((val: any) => (val.hasOwnProperty("divisionDataView") && val["divisionDataView"] == 3));
        }

        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.paginator.totalRows = data.length;
        this.showLoader = false;
        this.disablePageSelection = false;
        return data;
      }

    }).catch(async error => {
      // most likely the user record doesn't exist, create it
      if (error.code === "ERR_BAD_REQUEST") {
        await this.addSavedFilterUser();
      }
    });
  }


  clickRadioButton(event: Event) {
    let choice = (event.target as HTMLInputElement).value;

    //map the radio button chosen to the data
    //filterName is unique identifier !!!
    let chosenRow = this.dataSource.filteredData.find(row => row.filterName==choice);
    if(chosenRow){
      // @ts-ignore
      this.filterName = chosenRow.filterName;
      // @ts-ignore
      this.Region = chosenRow.Region;
      // @ts-ignore
      this.Countries = chosenRow.Countries;
      // @ts-ignore
      this.TopLevelContractGroup = chosenRow.contractModel.TopLevelContractGroup;
      // @ts-ignore
      this.SecondLevelContractFilter = chosenRow.contractModel.SecondLevelContractFilter;
      // @ts-ignore
      this.ThirdLevelContractFilter = chosenRow.contractModel.ThirdLevelContractFilter;
      // @ts-ignore
      this.FourthLevelContractFilter = chosenRow.contractModel.FourthLevelContractFilter;
      // @ts-ignore
      this.Period = chosenRow.Period;
      // @ts-ignore
      this.Templates = chosenRow.Templates;
      // @ts-ignore
      this.Accts = chosenRow.contractModel.Accts;
    }else{
      let errorMsg = `Error finding ${choice} row in clickRadioButton(), chosenRow undefined.`;
      console.log(errorMsg);
      alert(errorMsg);
    }
  }


  async delSavedFilterSet() {
    if (this.filterName === '') {
      window.alert('Please select a filter set.');
    } else {
      if (confirm("Are you sure to delete '" + this.filterName + "' ?")) {
        return await this.filterRequests.delSavedFilterSet(this.filterName, this.divDataView).then(response => {
          this.getSavedFilterSets();
          this.filterName = '';
        }).catch(async error => {
          console.log("delSavedFilterSet: " + JSON.stringify(error));
        });
      }
      return false;
    }
  }


  async addSavedFilterUser() {
    return await this.filterRequests.addSavedFilterUser(this.divDataView).then(response => {
      const data = response.data.savedFilters;
      this.dataSource = data;

      if (data[0] === undefined) {
        this.showNoData = true;
        this.hideApplyButton = true;
      } else {
        return data;
      }

    }).catch(async error => {
      console.log('addSavedFilterUser:' + JSON.stringify(error));
    });
  }


  async clickApplyButton() {
    if (this.filterName === '') {
      window.alert('Please select a filter set.');

    } else {
      var selections : ContractModel = {
        division: '',
        dataView: '',
        topLevelContractGroup: this.TopLevelContractGroup,
        secondLevelContractFilter: this.SecondLevelContractFilter,
        thirdLevelContractFilter: this.ThirdLevelContractFilter,
        fourthLevelContractFilter: this.FourthLevelContractFilter,
        accts: this.Accts,
        regions: this.Region,
        countries: this.Countries.split(','),
        period: this.Period,
        presentationType: undefined,
        translation: undefined,
        dateRange: undefined
      }
      await this.filterService.setSavedSelectionFilter(selections);

      // if browser is reset, this disappears telling app not to remember settings (clean)
      sessionStorage.setItem('prefillAll'+this.divDataView, '1');

      this.hideFilterRecallPanel.emit();
      this.recallSavedFilters.emit();
    }
  }


  clickCloseLink() {
    this.hideFilterRecallPanel.emit();
  }



  keyEvent(event: { keyCode: number; preventDefault: () => void; })
  {
    if(event.keyCode === 13)
    {
      event.preventDefault();
      this.clickApplyButton();
    }

    if(event.keyCode === 27)
    {
      event.preventDefault();
      this.clickCloseLink();
    }
  }

}
